import React from "react";
import "./BlurbStyles.css";

const Blurb = () => {
  return (
    <div>
      <div className="blurb-img">
        <div className="heading">
          <h1>About East Coast Landscapes</h1>
          <p className="intro-text">
            East Coast Landscapes is a Durham Based Hardscape Construction
            Company with over 25 Years Experience.
          </p>
          
          <h2>We specialize in projects such as:</h2>
          <ul className="services-list">
            <li>Interlocking Brick</li>
            <li>Patios and Driveways</li>
            <li>Retaining Walls</li>
            <li>Steps</li>
            <li>Fences</li>
            <li>Decks</li>
            <li>Landscape Lighting</li>
            <li>Fire Pits</li>
            <li>Sodding</li>
            <li>and More!</li>
          </ul>

          <div className="contact-cta">
            <h2>Get Your Free Quote Today!</h2>
            <p>
              Contact Mike @ <a href="tel:289-356-2717">289-356-2717</a>
              {" "}or{" "}
              <a href="mailto:eastcoastlandscapes1@gmail.com?subject=Website Inquiry">
                email us
              </a>
              {" "}to get a quote today!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blurb;
